const ro = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Se încarcă...',
    error: 'Eroare',
    save: 'Salvare',
    cancel: 'Anulare',
    delete: 'Ștergere',
    edit: 'Editare',
    create: 'Creare',
    add: 'Adăugare',
    remove: 'Eliminare',
    close: 'Închidere',
    confirm: 'Confirmare',
    apply: 'Aplicare',
    reset: 'Resetare',
    search: 'Căutare',
    filter: 'Filtru',
    clear: 'Golire',
    back: 'Înapoi',
    next: 'Următorul',
    previous: 'Anterior',
    submit: 'Trimitere',
    update: 'Actualizare',
    refresh: 'Reîmprospătare',
    export: 'Exportare',
    import: 'Importare',
    download: 'Descărcare',
    upload: 'Încărcare',
    print: 'Tipărire',
    copy: 'Copiere',
    yes: 'Da',
    no: 'Nu',
    ok: 'OK',
    done: 'Gata',
    select: 'Selectare',
    selectAll: 'Selectare totală',
    deselectAll: 'Deselectare totală',
    noResults: 'Nu s-au găsit rezultate',
    noData: 'Nu sunt date disponibile',
    required: 'Obligatoriu',
    optional: 'Opțional',
    actions: 'Acțiuni',
    details: 'Detalii',
    overview: 'Prezentare generală',
    summary: 'Rezumat',
    total: 'Total',
    all: 'Toate',
    none: 'Niciunul',
    name: 'Nume',
    type: 'Tip',
    status: 'Stare',
    date: 'Dată',
    time: 'Oră',
    description: 'Descriere',
    notes: 'Note',
    comments: 'Comentarii',
    category: 'Categorie',
    priority: 'Prioritate',
    nation: 'Stat',
    country: 'Țară',
    email: 'E-mail',
    phone: 'Telefon',
    address: 'Adresă',
    location: 'Locație',
    coordinates: 'Coordonate',
    latitude: 'Latitudine',
    longitude: 'Longitudine',
    from: 'De la',
    to: 'Către',
    createdAt: 'Creat',
    updatedAt: 'Actualizat',
    createdBy: 'Creat de',
    modifiedBy: 'Modificat de',
    active: 'Activ',
    inactive: 'Inactiv',
    enabled: 'Activat',
    disabled: 'Dezactivat',
    showing: 'Se afișează',
    of: 'din',
    page: 'Pagina',
    perPage: 'pe pagină',
    rows: 'rânduri',
    items: 'elemente',
    results: 'rezultate',
    sortBy: 'Sortare după',
    ascending: 'Crescător',
    descending: 'Descrescător',
    viewAll: 'Vizualizare totală',
    viewDetails: 'Vizualizare detalii',
    goBack: 'Înapoi',
    learnMore: 'Aflați mai multe',
    seeMore: 'Vedeți mai multe',
    showMore: 'Afișare mai multe',
    showLess: 'Afișare mai puține',
    expandAll: 'Expandare totală',
    collapseAll: 'Restrângere totală',
    copied: 'Copiat!',
    saved: 'Salvat!',
    deleted: 'Șters!',
    updated: 'Actualizat!',
    created: 'Creat!',
    success: 'Succes',
    warning: 'Avertizare',
    info: 'Informație',
    danger: 'Pericol',
    unknown: 'Necunoscut',
    notAvailable: 'Indisponibil',
    never: 'Niciodată',
    today: 'Astăzi',
    yesterday: 'Ieri',
    tomorrow: 'Mâine',
    now: 'Acum',
    ago: 'în urmă',
    justNow: 'chiar acum',
    minutesAgo: 'acum {{count}} min',
    hoursAgo: 'acum {{count}} ore',
    daysAgo: 'acum {{count}} zile',
    monthsAgo: 'acum {{count}} luni',
    id: 'ID',
    version: 'Versiune',
    language: 'Limbă',
    theme: 'Temă',
    darkMode: 'Mod întunecat',
    lightMode: 'Mod luminos',
    failedToLoad: 'Încărcarea datelor a eșuat',
    failedToSave: 'Salvarea a eșuat',
    failedToDelete: 'Ștergerea a eșuat',
    failedToUpdate: 'Actualizarea a eșuat',
    confirmDelete: 'Sigur doriți să ștergeți acest element?',
    confirmAction: 'Sunteți sigur?',
    unsavedChanges: 'Aveți modificări nesalvate. Sigur doriți să părăsiți pagina?',
    pageNotFound: '404 – Pagina nu a fost găsită',
    pageNotFoundDesc: 'Pagina pe care o căutați nu există.',
    backToDashboard: 'Înapoi la panou',
    characters: 'caractere',
    maxCharacters: 'Maxim {{max}} caractere',
    remaining: '{{count}} rămase',
    selected: '{{count}} selectate',
    of_total: '{{count}} din {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Panou',
    requests: 'Cereri',
    transports: 'Transporturi',
    myPatients: 'Pacienții mei',
    statistics: 'Statistici',
    flow: 'Flux',
    resources: 'Resources',
    exercise: 'Exercițiu',
    administration: 'Administrare',
    map: 'Hartă',
    info: 'Informații',
    users: 'Utilizatori',
    assets: 'Resurse',
    hubs: 'Noduri',
    treatmentFacilities: 'Unități medicale',
    patientImport: 'Import pacienți',
    assetTemplates: 'Șabloane resurse',
    dayTemplates: 'Șabloane zilnice',
    announcementTicker: 'Bandă de anunțuri',
    exerciseStatistics: 'Statistici exercițiu',
    settings: 'Setări',
    auditLog: 'Jurnal de audit',
    exerciseControl: 'Control exercițiu',
    dataSync: 'Sincronizare date',
    documentation: 'Documentație',
    support: 'Asistență',
    about: 'Despre',
    assetContracts: 'Asset Contracts',
    notifications: 'Notificări',
    schedules: 'Orare',
    capacityPlanning: 'Planificare capacitate',
    transportPlanning: 'Planificare transport',
    transportBooking: 'Rezervare transport',
    flowDiagram: 'Diagramă de flux',
    changePassword: 'Schimbare parolă',
    missions: 'Misiuni',
    startPoints: 'Puncte de plecare',
    hospital: 'Spital',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Autentificare',
    logout: 'Deconectare',
    logoutNow: 'Deconectare acum',
    loggingIn: 'Se autentifică...',
    loginFailed: 'Autentificarea a eșuat',
    email: 'E-mail',
    password: 'Parolă',
    username: 'Nume de utilizator',
    enterEmail: 'Introduceți adresa de e-mail',
    enterPassword: 'Introduceți parola',
    enterUsername: 'Introduceți numele de utilizator',
    forgotPassword: 'Ați uitat parola?',
    forgotPasswordTitle: 'Parolă uitată',
    forgotPasswordDesc: 'Introduceți numele de utilizator și adresa de e-mail. Dacă ambele corespund, administratorii vor fi notificați pentru resetarea parolei.',
    requestPasswordReset: 'Solicitare resetare parolă',
    sending: 'Se trimite...',
    backToLogin: 'Înapoi la autentificare',
    pleaseWait: 'Vă rugăm să așteptați înainte de a încerca din nou.',
    requestFailed: 'Solicitarea a eșuat',
    credentialsMatch: 'Dacă datele de autentificare corespund, administratorii au fost notificați.',
    forAccess: 'Pentru acces, vă rugăm să contactați administratorul de sistem.',
    changePassword: 'Schimbare parolă',
    currentPassword: 'Parola curentă',
    newPassword: 'Parola nouă',
    confirmPassword: 'Confirmare parolă',
    passwordChanged: 'Parola a fost schimbată cu succes',
    passwordMismatch: 'Parolele nu corespund',
    passwordTooShort: 'Parola trebuie să aibă cel puțin 8 caractere',
    changingPassword: 'Se schimbă...',
    mustChangePassword: 'Trebuie să vă schimbați parola înainte de a continua.',
    sessionExpiring: 'Sesiunea expiră',
    sessionExpireText: 'Sesiunea dumneavoastră va expira în <strong>{{time}}</strong>. Vă rugăm să salvați munca și să vă autentificați din nou.',
    dismiss: 'Închidere',
    switchNation: 'Schimbare stat',
    returnTo: 'Revenire la {{nation}}',
    viewingAs: 'Vizualizați ca',
    loggedInAs: 'autentificat ca {{nation}}',
    trainingMode: 'EXCLUSIV PENTRU SCOPURI DE INSTRUIRE',
    dedication: 'Creat cu dragoste și dedicare față de profesie',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Administrator sistem',
    excon: 'Controlor exercițiu',
    eu: 'Coordonator UE',
    planner: 'Planificator',
    hub: 'Manager nod',
    nation: 'Stat',
    readOnly: 'Doar citire',
    systemAdmin: 'Administrator de sistem',
    transportPlanner: 'Planificator transport',
    systemRoles: 'Roluri de sistem',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Ciornă',
    underReview: 'În revizuire',
    published: 'Publicat',
    underSelection: 'În selecție',
    accepted: 'Acceptat',
    planned: 'Planificat',
    inTransit: 'În tranzit',
    completed: 'Finalizat',
    closed: 'Închis',
    withdrawn: 'Retras',
    pending: 'În așteptare',
    rejected: 'Respins',
    cancelled: 'Anulat',
    active: 'Activ',
    inactive: 'Inactiv',
    review: 'Revizuire',
    selection: 'Selecție',
    transit: 'Tranzit',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personal',
    material: 'Material',
    equipment: 'Echipament',
    other: 'Altele',
    news: 'Știri',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Rutină',
    priority: 'Prioritar',
    urgent: 'Urgent',
    immediate: 'Imediat',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Tren',
    ship: 'Navă',
    aircraft: 'Aeronavă',
    bus: 'Autobuz',
    ambulance: 'Ambulanță',
    drone: 'Dronă',
    helicopter: 'Elicopter',
    ferry: 'Feribot',
    other: 'Altele',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Panou',
    goodMorning: 'Bună dimineața',
    goodAfternoon: 'Bună ziua',
    goodEvening: 'Bună seara',
    lastLogin: 'Ultima autentificare',
    infrastructure: 'Infrastructură',
    transportAssets: 'Resurse de transport',
    treatmentFacilities: 'Unități medicale',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Statistici cereri',
    viewAllRequests: 'Vizualizare toate cererile',
    availableAssets: 'Resurse disponibile',
    seated: 'Așezat',
    lying: 'Culcat',
    intensive: 'Intensiv',
    notifications: 'Notificări',
    markAllRead: 'Marcare toate ca citite',
    noNotifications: 'Încă nu există notificări',
    notifiedWhenActivity: 'Veți fi notificat când apare o activitate nouă',
    viewDetailsBtn: 'Vizualizare detalii',
    nationUsers: 'Utilizatori stat',
    user: 'Utilizator',
    roles: 'Roluri',
    noUsersFound: 'Nu s-au găsit utilizatori',
    participatingNations: 'State participante',
    exerciseDisclaimer: 'Acest sistem este destinat exclusiv exercițiilor. Introduceți doar date simulate de exercițiu. Fluxurile de lucru sunt adaptate scenariului de exercițiu și pot diferi de procedurile reale. Regulile de securitate IT și protecție a datelor rămân pe deplin aplicabile.',
    notConfigured: 'Neconfigurat',
    requestCount: '{{count}} cerere(i)',
    clickToView: 'Faceți clic pentru vizualizare',
    systemAdministration: 'Administrare sistem',
    exerciseControlTitle: 'Control exercițiu',
    euCoordination: 'Coordonare UE',
    transportPlanningTitle: 'Planificare transport',
    hubManagement: 'Gestionare noduri',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Cerere nouă',
    myDrafts: 'Ciornele mele',
    pendingReview: 'În așteptare pentru revizuire',
    activeTransports: 'Transporturi active',
    myPatients: 'Pacienții mei',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Cereri',
    newRequest: 'Cerere nouă',
    createRequest: 'Creare cerere',
    editRequest: 'Editare cerere',
    requestDetail: 'Detalii cerere',
    requestId: 'ID cerere',
    fromNation: 'De la statul',
    toNation: 'Către statul',
    requestingNation: 'Stat solicitant',
    receivingNation: 'Stat destinatar',
    category: 'Categorie',
    urgency: 'Urgență',
    status: 'Stare',
    patients: 'Pacienți',
    patientCount: 'Număr pacienți',
    offers: 'Oferte',
    offerCount: 'Număr oferte',
    created: 'Creat',
    updated: 'Actualizat',
    submittedBy: 'Trimis de',
    reviewedBy: 'Revizuit de',
    description: 'Descriere',
    medicalDetails: 'Detalii medicale',
    transportDetails: 'Detalii transport',
    additionalInfo: 'Informații suplimentare',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Punct de plecare',
    arrivalPoint: 'Punct de sosire',
    estimatedDeparture: 'Plecare estimată',
    estimatedArrival: 'Sosire estimată',
    submitForReview: 'Trimitere spre revizuire',
    publish: 'Publicare',
    startSelection: 'Începere selecție',
    acceptOffer: 'Acceptare ofertă',
    markInTransit: 'Marcare ca în tranzit',
    markCompleted: 'Marcare ca finalizat',
    closeRequest: 'Închidere cerere',
    withdrawRequest: 'Retragere cerere',
    withdraw: 'Retragere',
    revertToDraft: 'Revenire la ciornă',
    deleteRequest: 'Ștergere cerere',
    duplicateRequest: 'Duplicare cerere',
    createFollowUp: 'Creare cerere consolidată',
    followUpRequest: 'Cerere consolidată',
    parentRequest: 'Cerere originală',
    childRequests: 'Cereri consolidate',
    noRequests: 'Nu s-au găsit cereri',
    noOffers: 'Încă nu există oferte',
    addPatient: 'Adăugare pacient',
    removePatient: 'Eliminare pacient',
    patientDetails: 'Detalii pacient',
    contactPerson: 'Persoană de contact',
    contactPhone: 'Telefon de contact',
    contactEmail: 'E-mail de contact',
    specialRequirements: 'Cerințe speciale',
    medicalEquipment: 'Echipament medical',
    accompaniment: 'Însoțire',
    timeline: 'Cronologie',
    history: 'Istoric',
    addComment: 'Adăugare comentariu',
    writeComment: 'Scrieți un comentariu...',
    postComment: 'Publicare comentariu',
    posting: 'Se publică...',
    noComments: 'Încă nu există comentarii',
    coverageBar: 'Acoperire',
    covered: 'acoperit',
    uncovered: 'neacoperit',
    filterByStatus: 'Filtrare după stare',
    filterByCategory: 'Filtrare după categorie',
    filterByNation: 'Filtrare după stat',
    searchRequests: 'Căutare cereri...',
    confirmWithdraw: 'Sigur doriți să retrageți această cerere?',
    confirmDelete: 'Sigur doriți să ștergeți această cerere?',
    confirmPublish: 'Sigur doriți să publicați această cerere? Va fi vizibilă pentru toate statele.',
    confirmStartSelection: 'Sigur doriți să începeți selecția? Statele vor putea face oferte.',
    warningStartSelection: 'Începerea selecției va face această cerere vizibilă pentru toate statele participante. Acestea vor putea trimite oferte pentru pacienții din această cerere. Această acțiune nu poate fi anulată.',
    warningMakeOffer: 'Prin trimiterea acestei oferte, statul dumneavoastră se angajează să furnizeze asistența propusă. Această acțiune va notifica statul solicitant și controlul exercițiului.',
    saveDraft: 'Salvare ciornă',
    saving: 'Se salvează...',
    saveAndSubmit: 'Salvare și trimitere',
    step: 'Pasul {{number}}',
    generalInfo: 'Informații generale',
    patientInfo: 'Informații pacient',
    logisticsInfo: 'Informații logistice',
    reviewSubmit: 'Revizuire și trimitere',
    requestTitle: 'Titlu cerere',
    requestDescription: 'Descriere cerere',
    numberOfPatients: 'Număr de pacienți',
    typeOfAssistance: 'Tip de asistență',
    medicalTreatment: 'Tratament medical',
    transportAssistance: 'Asistență transport',
    both: 'Ambele',
    treatmentOnly: 'Doar tratament',
    transportOnly: 'Doar transport',
    validationErrors: 'Vă rugăm să corectați următoarele erori:',
    fieldRequired: 'Acest câmp este obligatoriu',
    selectExitHub: 'Selectați un nod de ieșire',
    createExitHub: 'Creare nod de ieșire',
    backToRequests: 'Înapoi la cereri',
    noRequestsFound: 'Nu s-au găsit cereri',
    createFirstRequest: 'Creați prima cerere pentru a începe',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Oferte',
    createOffer: 'Creare ofertă',
    makeOffer: 'Trimitere ofertă',
    manageOffers: 'Gestionare oferte',
    offerDetail: 'Detalii ofertă',
    offerId: 'ID ofertă',
    offeringNation: 'Stat ofertant',
    offerType: 'Tip ofertă',
    treatment: 'Tratament',
    transport: 'Transport',
    combined: 'Combinată',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Ofertă de tratament',
    transportOffer: 'Ofertă de transport',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Selectare pacienți',
    selectedPatients: 'Pacienți selectați',
    patientSelection: 'Selecție pacienți',
    offerConfiguration: 'Configurare ofertă',
    reviewOffer: 'Revizuire ofertă',
    submitOffer: 'Trimitere ofertă',
    submitting: 'Se trimite...',
    acceptOffer: 'Acceptare ofertă',
    rejectOffer: 'Respingere ofertă',
    withdrawOffer: 'Retragere ofertă',
    noOffers: 'Nu sunt oferte disponibile',
    noOffer: 'No Offer',
    offerStatus: 'Stare ofertă',
    offerDate: 'Data ofertei',
    transportAsset: 'Resursă de transport',
    departureDate: 'Data plecării',
    arrivalDate: 'Data sosirii',
    treatmentFacility: 'Unitate medicală',
    capacity: 'Capacitate',
    availableCapacity: 'Capacitate disponibilă',
    totalCapacity: 'Capacitate totală',
    selectAsset: 'Selectare resursă',
    selectFacility: 'Selectare unitate',
    offerNotes: 'Note ofertă',
    confirmAccept: 'Sigur doriți să acceptați această ofertă?',
    confirmReject: 'Sigur doriți să respingeți această ofertă?',
    extendTransport: 'Extindere transport',
    transportExtension: 'Extindere transport',
    comparisonView: 'Vizualizare comparativă',
    shortlist: 'Listă scurtă',
    addToShortlist: 'Adăugare la lista scurtă',
    removeFromShortlist: 'Eliminare din lista scurtă',
    leaveConfirmTitle: 'Părăsiți această pagină?',
    leaveConfirmMessage: 'Aveți modificări nesalvate. Sigur doriți să plecați?',
    stayOnPage: 'Rămâneți pe pagină',
    leavePage: 'Părăsire pagină',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transporturi',
    missionDetail: 'Detalii transport',
    missionId: 'ID transport',
    missionStatus: 'Stare transport',
    createMission: 'Creare transport',
    overview: 'Prezentare generală',
    patientsTab: 'Pacienți',
    transportsTab: 'Segmente transport',
    treatmentTab: 'Tratament',
    reviewTab: 'Revizuire',
    departure: 'Plecare',
    arrival: 'Sosire',
    origin: 'Origine',
    destination: 'Destinație',
    stops: 'Opriri',
    addStop: 'Adăugare oprire',
    removeStop: 'Eliminare oprire',
    stopName: 'Nume oprire',
    stopType: 'Tip oprire',
    estimatedTime: 'Oră estimată',
    actualTime: 'Oră efectivă',
    asset: 'Resursă',
    driver: 'Conducător',
    crew: 'Echipaj',
    noMissions: 'Nu s-au găsit transporturi',
    completeMission: 'Finalizare transport',
    cancelMission: 'Anulare transport',
    startTransport: 'Pornire transport',
    missionChain: 'Lanț de transport',
    linkedMissions: 'Transporturi legate',
    handover: 'Predare',
    handoverPoint: 'Punct de predare',
    pickupPoint: 'Punct de preluare',
    dropoffPoint: 'Punct de predare',
    searchTransports: 'Căutare transporturi...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacienți',
    myPatients: 'Pacienții mei',
    patientId: 'ID pacient',
    firstName: 'Prenume',
    lastName: 'Nume de familie',
    dateOfBirth: 'Data nașterii',
    age: 'Vârstă',
    gender: 'Gen',
    male: 'Masculin',
    female: 'Feminin',
    other: 'Altul',
    nationality: 'Cetățenie',
    diagnosis: 'Diagnostic',
    condition: 'Stare',
    stable: 'Stabil',
    critical: 'Critic',
    serious: 'Grav',
    treatmentNeeded: 'Tratament necesar',
    allergies: 'Alergii',
    medications: 'Medicație',
    bloodType: 'Grupa sanguină',
    weight: 'Greutate (kg)',
    infectious: 'Infecțios',
    mentalHealth: 'Sănătate mintală',
    mobility: 'Mobilitate',
    ambulatory: 'Ambulatoriu',
    wheelchair: 'Scaun cu rotile',
    stretcher: 'Targă',
    intensive: 'Terapie intensivă',
    oxygenRequired: 'Oxigen necesar',
    ventilator: 'Ventilator',
    medicalEscort: 'Escortă medicală',
    noPatients: 'Nu s-au găsit pacienți',
    patientDetails: 'Detalii pacient',
    medicalHistory: 'Istoric medical',
    travelDocuments: 'Documente de călătorie',
    passport: 'Pașaport',
    pseudonymizedId: 'ID pseudonimizat',
    sensitiveData: 'Date sensibile',
    journey: 'Traseul pacientului',
    assignedTo: 'Asignat la',
    currentLocation: 'Locația curentă',
    importPatients: 'Import pacienți',
    exportPatients: 'Export pacienți',
    seated: 'Așezat',
    lying: 'Culcat',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Utilizatori',
    createUser: 'Creare utilizator',
    editUser: 'Editare utilizator',
    deleteUser: 'Ștergere utilizator',
    username: 'Nume de utilizator',
    displayName: 'Nume afișat',
    email: 'E-mail',
    password: 'Parolă',
    role: 'Rol',
    roles: 'Roluri',
    nation: 'Stat',
    active: 'Activ',
    lastLogin: 'Ultima autentificare',
    createdAt: 'Creat',
    isNation: 'Stat',
    isEU: 'UE',
    isAdmin: 'Administrator',
    isExcon: 'EXCON',
    isPlanner: 'Planificator',
    isHub: 'Nod',
    isReadOnly: 'Doar citire',
    noUsers: 'Nu s-au găsit utilizatori',
    confirmDelete: 'Sigur doriți să ștergeți acest utilizator?',
    resetPassword: 'Resetare parolă',
    generatePassword: 'Generare parolă',
    searchUsers: 'Căutare utilizatori...',
    userCreated: 'Utilizator creat cu succes',
    userUpdated: 'Utilizator actualizat cu succes',
    userDeleted: 'Utilizator șters cu succes',
    selectNation: 'Selectați un stat',
    mustChangePassword: 'Trebuie să schimbe parola la următoarea autentificare',
    flagImage: 'Imagine steag',
    exportUsers: 'Export utilizatori',
    importUsers: 'Import utilizatori',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Resurse',
    createAsset: 'Creare resursă',
    editAsset: 'Editare resursă',
    deleteAsset: 'Ștergere resursă',
    assetName: 'Nume resursă',
    assetType: 'Tip resursă',
    capacitySeated: 'Capacitate (așezat)',
    capacityLying: 'Capacitate (culcat)',
    capacityIntensive: 'Capacitate (intensiv)',
    owner: 'Proprietar',
    operator: 'Operator',
    baseLocation: 'Locație de bază',
    range: 'Rază de acțiune',
    speed: 'Viteză',
    noAssets: 'Nu s-au găsit resurse',
    confirmDelete: 'Sigur doriți să ștergeți această resursă?',
    searchAssets: 'Căutare resurse...',
    assetCreated: 'Resursă creată cu succes',
    assetUpdated: 'Resursă actualizată cu succes',
    assetDeleted: 'Resursă ștearsă cu succes',
    exportAssets: 'Export resurse',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Noduri',
    startPoints: 'Puncte de plecare',
    createHub: 'Creare nod',
    editHub: 'Editare nod',
    deleteHub: 'Ștergere nod',
    hubName: 'Nume nod',
    hubType: 'Tip nod',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Nod de intrare',
    airport: 'Aeroport',
    seaport: 'Port maritim',
    railStation: 'Gară feroviară',
    roadPoint: 'Punct rutier',
    ucpmClassification: 'Clasificare UCPM',
    icaoCode: 'Cod ICAO',
    iataCode: 'Cod IATA',
    noHubs: 'Nu s-au găsit noduri',
    confirmDelete: 'Sigur doriți să ștergeți acest nod?',
    searchHubs: 'Căutare noduri...',
    nationAssignment: 'Asignare stat',
    assignNations: 'Asignare state',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Unități medicale',
    createFacility: 'Creare unitate',
    editFacility: 'Editare unitate',
    deleteFacility: 'Ștergere unitate',
    facilityName: 'Nume unitate',
    facilityType: 'Tip unitate',
    hospitalName: 'Nume spital',
    bedCapacity: 'Capacitate paturi',
    specialties: 'Specialități',
    availableBeds: 'Paturi disponibile',
    totalBeds: 'Total paturi',
    contactPerson: 'Persoană de contact',
    noFacilities: 'Nu s-au găsit unități medicale',
    confirmDelete: 'Sigur doriți să ștergeți această unitate?',
    searchFacilities: 'Căutare unități...',
    hubNationAssignment: 'Asignare nod-stat',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Orare',
    createSchedule: 'Creare orar',
    editSchedule: 'Editare orar',
    deleteSchedule: 'Ștergere orar',
    scheduleName: 'Nume orar',
    scheduleType: 'Tip orar',
    recurring: 'Recurent',
    oneTime: 'Unic',
    frequency: 'Frecvență',
    daily: 'Zilnic',
    weekly: 'Săptămânal',
    startDate: 'Data de început',
    endDate: 'Data de sfârșit',
    departureTime: 'Ora de plecare',
    arrivalTime: 'Ora de sosire',
    stops: 'Opriri',
    addStop: 'Adăugare oprire',
    noSchedules: 'Nu s-au găsit orare',
    bookings: 'Rezervări',
    timeline: 'Cronologie',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Notificări',
    markAllRead: 'Marcare toate ca citite',
    markAsRead: 'Marcare ca citit',
    markAsUnread: 'Marcare ca necitit',
    noNotifications: 'Nu există notificări',
    viewAll: 'Vizualizare toate notificările',
    settings: 'Setări notificări',
    emailNotifications: 'Notificări prin e-mail',
    inAppNotifications: 'Notificări în aplicație',
    notifyOn: 'Notifică-mă despre',
    requestCreated: 'Cerere nouă',
    requestPublished: 'Cerere publicată',
    requestClosed: 'Cerere închisă',
    requestCompleted: 'Cerere finalizată',
    commentAdded: 'Comentariu nou',
    offerReceived: 'Ofertă primită',
    offerAccepted: 'Ofertă acceptată',
    statusChanged: 'Stare modificată',
    selectionStarted: 'Selecție începută',
    missionCreated: 'Transport creat',
    missionStatusUpdated: 'Transport actualizat',
    transportPartnerNamed: 'Partener de transport',
    transportExtensionReceived: 'Extindere transport',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Setări',
    general: 'General',
    system: 'Sistem',
    email: 'E-mail',
    sync: 'Sincronizare',
    security: 'Securitate',
    appearance: 'Aspect',
    systemName: 'Nume sistem',
    systemEmail: 'E-mail sistem',
    maintenanceMode: 'Mod mentenanță',
    readOnlyMode: 'Mod doar citire',
    emailEnabled: 'E-mail activat',
    smtpHost: 'Gazdă SMTP',
    smtpPort: 'Port SMTP',
    smtpUser: 'Utilizator SMTP',
    smtpPassword: 'Parolă SMTP',
    senderEmail: 'E-mail expeditor',
    senderName: 'Nume expeditor',
    testEmail: 'Trimitere e-mail de test',
    syncEnabled: 'Sincronizare activată',
    syncUrl: 'URL sincronizare',
    syncApiKey: 'Cheie API sincronizare',
    settingsSaved: 'Setările au fost salvate cu succes',
    helpdesk: 'Serviciu asistență',
    helpdeskTitle: 'Titlu serviciu asistență',
    helpdeskEmail: 'E-mail serviciu asistență',
    helpdeskPhone: 'Telefon serviciu asistență',
    helpdeskInfo: 'Informații serviciu asistență',
    realLifeSupport: 'Asistență în viața reală',
    trainingMode: 'Mod de instruire',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Jurnal de audit',
    action: 'Acțiune',
    user: 'Utilizator',
    target: 'Țintă',
    details: 'Detalii',
    timestamp: 'Marcaj temporal',
    ipAddress: 'Adresă IP',
    noLogs: 'Nu s-au găsit înregistrări de audit',
    searchLogs: 'Căutare înregistrări...',
    filterByAction: 'Filtrare după acțiune',
    filterByUser: 'Filtrare după utilizator',
    exportLogs: 'Export înregistrări',
    exportCsv: 'Export CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Control exercițiu',
    currentDay: 'Ziua curentă',
    exerciseDay: 'Ziua exercițiului',
    nextDay: 'Ziua următoare',
    previousDay: 'Ziua anterioară',
    resetExercise: 'Resetare exercițiu',
    startExercise: 'Pornire exercițiu',
    endExercise: 'Încheiere exercițiu',
    dayReset: 'Resetare zi',
    confirmReset: 'Sigur doriți să resetați ziua exercițiului? Aceasta va șterge toate datele zilei curente.',
    resetInProgress: 'Resetare în curs...',
    maintenanceMode: 'Mod mentenanță',
    enableMaintenance: 'Activare mentenanță',
    disableMaintenance: 'Dezactivare mentenanță',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Sincronizare date',
    syncStatus: 'Stare sincronizare',
    lastSync: 'Ultima sincronizare',
    pendingItems: 'Elemente în așteptare',
    syncNow: 'Sincronizare acum',
    syncing: 'Se sincronizează...',
    syncSuccess: 'Sincronizare finalizată cu succes',
    syncFailed: 'Sincronizarea a eșuat',
    outbox: 'Ieșire',
    inbox: 'Intrare',
    configuration: 'Configurare',
    targetUrl: 'URL țintă',
    apiKey: 'Cheie API',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Hartă',
    layers: 'Straturi',
    requests: 'Cereri',
    hubs: 'Noduri',
    facilities: 'Unități',
    routes: 'Rute',
    showAll: 'Afișare toate',
    hideAll: 'Ascundere toate',
    zoomIn: 'Mărire',
    zoomOut: 'Micșorare',
    resetView: 'Resetare vizualizare',
    satellite: 'Satelit',
    terrain: 'Teren',
    offline: 'Offline',
    online: 'Online',
    tilesOffline: 'Tile-urile hărții sunt servite local',
    tilesOnline: 'Tile-urile hărții sunt încărcate de pe servere online',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistici',
    overview: 'Prezentare generală',
    requestsByStatus: 'Cereri după stare',
    requestsByCategory: 'Cereri după categorie',
    requestsByNation: 'Cereri după stat',
    offersByStatus: 'Oferte după stare',
    patientsByCondition: 'Pacienți după stare',
    transportsByStatus: 'Transporturi după stare',
    timeline: 'Cronologie',
    totalRequests: 'Total cereri',
    totalOffers: 'Total oferte',
    totalPatients: 'Total pacienți',
    totalTransports: 'Total transporturi',
    averageResponseTime: 'Timp mediu de răspuns',
    completionRate: 'Rată de finalizare',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Statistici exercițiu',
    overview: 'Prezentare generală',
    byCategory: 'După categorie',
    byNation: 'După stat',
    byDay: 'După zi',
    totalPatientsMoved: 'Total pacienți transportați',
    totalRequestsProcessed: 'Total cereri procesate',
    averageProcessingTime: 'Timp mediu de procesare',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Diagramă de flux',
    sankey: 'Sankey',
    nodeGraph: 'Grafic nodal',
    refresh: 'Reîmprospătare',
    noData: 'Nu sunt disponibile date de flux',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Despre',
    version: 'Versiune',
    systemInfo: 'Informații sistem',
    buildDate: 'Data construirii',
    environment: 'Mediu',
    description: 'ARCOS — Sistem avansat de comunicare a cererilor',
    subtitle: 'Asistență victime și operațiuni medicale',
    whatIsArcos: 'Ce este ARCOS? – Explicație pentru participanții la exercițiu',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Facilitat de MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – unde curiozitatea întâlnește colaborarea.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Documentație',
    gettingStarted: 'Primii pași',
    userGuide: 'Ghid utilizator',
    faq: 'Întrebări frecvente',
    troubleshooting: 'Depanare',
    apiReference: 'Referință API',
    downloadTemplate: 'Descărcare șablon',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Import pacienți',
    uploadFile: 'Încărcare fișier',
    selectFile: 'Selectare fișier',
    preview: 'Previzualizare',
    importNow: 'Importare acum',
    importing: 'Se importă...',
    importSuccess: '{{count}} pacienți importați cu succes',
    importFailed: 'Importul a eșuat',
    downloadTemplate: 'Descărcare șablon',
    dragDrop: 'Trageți și plasați un fișier aici, sau faceți clic pentru a selecta',
    supportedFormats: 'Formate acceptate: XLSX, XLS, CSV',
    rowsFound: '{{count}} rânduri găsite',
    validRows: '{{count}} rânduri valide',
    invalidRows: '{{count}} rânduri invalide',
    duplicateRows: '{{count}} rânduri duplicate',
    previewData: 'Previzualizare date',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Planificare transport',
    planRoute: 'Planificare rută',
    routeBuilder: 'Constructor rută',
    addWaypoint: 'Adăugare punct intermediar',
    removeWaypoint: 'Eliminare punct intermediar',
    estimatedDuration: 'Durată estimată',
    distance: 'Distanță',
    selectVehicle: 'Selectare vehicul',
  },

  transportBooking: {
    title: 'Rezervare transport',
    bookTransport: 'Rezervare transport',
    availableSlots: 'Locuri disponibile',
    bookingConfirmed: 'Rezervare confirmată',
    cancelBooking: 'Anulare rezervare',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Planificare capacitate',
    totalCapacity: 'Capacitate totală',
    usedCapacity: 'Capacitate utilizată',
    availableCapacity: 'Capacitate disponibilă',
    utilizationRate: 'Rată de utilizare',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Șabloane resurse',
    dayTemplates: 'Șabloane zilnice',
    createTemplate: 'Creare șablon',
    editTemplate: 'Editare șablon',
    deleteTemplate: 'Ștergere șablon',
    templateName: 'Nume șablon',
    applyTemplate: 'Aplicare șablon',
    noTemplates: 'Nu s-au găsit șabloane',
    confirmDelete: 'Sigur doriți să ștergeți acest șablon?',
    confirmApply: 'Sigur doriți să aplicați acest șablon? Aceasta va suprascrie datele existente.',
    exportTemplates: 'Export șabloane',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Bandă de anunțuri',
    createAnnouncement: 'Creare anunț',
    editAnnouncement: 'Editare anunț',
    deleteAnnouncement: 'Ștergere anunț',
    message: 'Mesaj',
    startTime: 'Ora de început',
    endTime: 'Ora de sfârșit',
    active: 'Activ',
    noAnnouncements: 'Nu există anunțuri',
    confirmDelete: 'Sigur doriți să ștergeți acest anunț?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Căutare...',
      noResults: 'Nu s-au găsit rezultate',
      showing: 'Se afișează {{from}} până la {{to}} din {{total}}',
      rowsPerPage: 'Rânduri pe pagină',
      previousPage: 'Pagina anterioară',
      nextPage: 'Pagina următoare',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Confirmare',
      cancel: 'Anulare',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Modificări nesalvate',
      message: 'Aveți modificări nesalvate. Sigur doriți să părăsiți această pagină?',
      stay: 'Rămâneți pe pagină',
      leave: 'Părăsire pagină',
    },
    // EmptyState
    emptyState: {
      noData: 'Nu sunt date disponibile',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Ceva nu a funcționat corect',
      message: 'A apărut o eroare neașteptată. Vă rugăm să încercați să reîmprospătați pagina.',
      retry: 'Reîncercare',
    },
    // ExportButton
    exportButton: {
      export: 'Exportare',
      exporting: 'Se exportă...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Tipărire',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Ciornă',
      review: 'Revizuire',
      published: 'Publicat',
      selection: 'Selecție',
      inTransit: 'În tranzit',
      completed: 'Finalizat',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Instanță online',
      message: 'Mod doar citire. Datele sunt sincronizate de pe serverul principal.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Vizualizați ca',
      loggedInAs: 'autentificat ca {{nation}}',
      returnTo: 'Revenire la {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Căutare pagini, cereri, transporturi...',
      searching: 'Se caută...',
      noResults: 'Niciun rezultat pentru „{{query}}"',
      navigate: 'Navigare',
      select: 'Selectare',
      close: 'Închidere',
      pages: {
        dashboard: 'Panou',
        requests: 'Cereri',
        transports: 'Transporturi',
        map: 'Hartă',
        myPatients: 'Pacienții mei',
        flowDiagram: 'Diagramă de flux',
        statistics: 'Statistici',
        assets: 'Resurse',
        startPoints: 'Puncte de plecare / Noduri',
        treatmentFacilities: 'Unități medicale',
        users: 'Utilizatori',
        settings: 'Setări',
        auditLogs: 'Jurnal de audit',
        exerciseControl: 'Control exercițiu',
        dataSync: 'Sincronizare date',
        patientImport: 'Import pacienți',
        notifications: 'Notificări',
        documentation: 'Documentație',
      },
      actions: {
        importPatientsJson: 'Importă Pacienți (JSON)',
        importPatientsExcel: 'Importă Pacienți (Excel)',
        importUsers: 'Importă Utilizatori (Excel)',
        importAssetTemplates: 'Importă Șabloane de Active (Excel)',
        importDayTemplates: 'Importă Intrări Șablon Zilnic (Excel)',
        exportRequests: 'Exportă Cereri (Excel)',
        exportPatients: 'Exportă Pacienți (Excel)',
        exportUsers: 'Exportă Utilizatori (Excel)',
        exportCredentials: 'Exportă Credențiale (PDF)',
        exportAuditExcel: 'Exportă Jurnal de audit (Excel)',
        exportAuditPdf: 'Exportă Jurnal de audit (PDF)',
        pagePatientImport: 'Pagina de import pacienți',
        pageRequestDetail: 'Pagina de detalii cerere',
        pageUsers: 'Pagina de gestionare utilizatori',
        pageAssetTemplates: 'Pagina de șabloane de active',
        pageDayTemplates: 'Pagina de șabloane zilnice',
        pageRequests: 'Pagina de listă cereri',
        pageAuditLogs: 'Pagina de jurnal de audit',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesiunea expiră',
      message: 'Sesiunea dumneavoastră va expira în <strong>{{time}}</strong>. Vă rugăm să salvați munca și să vă autentificați din nou.',
      dismiss: 'Închidere',
      logoutNow: 'Deconectare acum',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Selectați 4 fusuri orare',
      configure: 'Configurare fusuri orare',
      reset: 'Resetare',
      apply: 'Aplicare',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Selectare locație',
      latitude: 'Latitudine',
      longitude: 'Longitudine',
      clickToSelect: 'Faceți clic pe hartă pentru a selecta o locație',
    },
    // Modal
    modal: {
      close: 'Închidere',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Acasă',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Mentenanță sistem',
    message: 'Sistemul este resetat pentru următoarea zi de exercițiu. Vă rugăm să așteptați finalizarea procesului.',
    autoRefresh: 'Această pagină se va reîmprospăta automat când sistemul va fi din nou disponibil.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Cel puțin 10 caractere',
    uppercase: '1 literă mare',
    lowercase: '1 literă mică',
    digit: '1 cifră',
    special: '1 caracter special',
  },
};

export default ro;
